/* eslint-disable unicorn/no-nested-ternary -- clashes with prettier */
import type { Theme } from '@ori-ui/mui';
import { makeStyles } from '@mui/styles';

interface Props {
    isActiveInput: boolean;
    isCorrectInputData: boolean;
    inputData: string;
}

const isValid = ({ isCorrectInputData, inputData }: Props) => isCorrectInputData && !!inputData.length;
const isInvalid = ({ isCorrectInputData, inputData }: Props) => !inputData.length || !isCorrectInputData;

const buttonAndInformationBase: Record<string, string> = {
    position: 'absolute',
    bottom: '0',
    padding: '0',
    transition: '0.3s',
    border: 'none',
    backgroundColor: 'transparent',
    fontSize: '30px',
    cursor: 'pointer',
};

export const useClassNames = makeStyles<Theme, Props>((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: '0 0 5px 5px',
        backgroundColor: theme.palette.common.white,
    },

    form: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },

    formField: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        marginBottom: '5px',
    },

    inputLabel: {
        marginBottom: '11px',
        color: (props) => (isInvalid(props) ? theme.palette.error.main : theme.palette.text.secondary),
        fontSize: '12px',
        lineHeight: '20px',
    },

    inputField: {
        boxSizing: 'border-box',
        height: '28px',
        padding: '10px 0',
        border: `solid ${theme.palette.grey[300]}`,
        borderWidth: '0 0 1px 0',
        outline: 'none',
        fontSize: '14px',
        lineHeight: '19px',
        borderBottomColor: (props) => (isInvalid(props) ? theme.palette.error.main : theme.palette.grey[300]),
    },

    validateInfo: {
        margin: '0 0 10px',
        color: theme.palette.error.main,
        fontSize: '12px',
        lineHeight: '20px',
        opacity: (props) => (isInvalid(props) ? 1 : 0),
        [theme.breakpoints.up(768)]: {
            marginBottom: 0,
        },
    },

    button: {
        ...buttonAndInformationBase,
        display: 'flex',
        right: (props) => (isInvalid(props) ? '30px' : 0),
        color: (props) =>
            isValid(props)
                ? theme.palette.primary.main
                : isInvalid(props)
                ? theme.palette.error.main
                : theme.palette.grey[300],
    },

    information: {
        ...buttonAndInformationBase,
        right: 0,
        display: 'flex',
        opacity: (props) => (isInvalid(props) ? 1 : 0),
        color: (props) => (isInvalid(props) ? theme.palette.error.main : theme.palette.grey[300]),
    },
}));
